import validate from 'validate.js';
import arrayLength from './arrayLength';
import presenceContent from './presenceContent';
import presenceVideo from './presenceVideo';
import externalVideoLink from './externalVideoLink';
import greaterThan from './greaterThan';
import notEquality from './notEquality';
import password from './password';
import minImageSizeAsync from './minImageSize';
import vodVideo from './vodVideo';

validate.validators.presence.message = 'is missing';
validate.validators.email.message = '^Please enter valid e-mail';
validate.validators.length.tooShort =
  'should contain at least %{count} characters';

validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  // eslint-disable-next-line no-unused-vars
  parse: function(value, options) {
    return value;
  },
  // Input is a unix timestamp
  // eslint-disable-next-line no-unused-vars
  format: function(value, options) {
    return value;
  }
});

Object.assign(validate.validators, {
  password,
  arrayLength,
  greaterThan,
  notEquality,
  presenceContent,
  minImageSizeAsync,
  presenceVideo,
  externalVideoLink,
  vodVideo
});

export function validateRedux(data, validationRules) {
  return validate(data, validationRules) || {};
}

export async function validateAsyncRedux(data, validationRules) {
  try {
    await validate.async(data, validationRules);

    return {};
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    throw err;
  }
}

export default validate;



// WEBPACK FOOTER //
// ./src/utilites/validate/index.js